import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import store from '@blade-sxp/screen/store/index';
import MapCommon from '@blade-sxp/map-new/index.vue';
// import { MapData, MapType, Weather } from '@blade-sxp/screen/interface';
import MapLoading from '@blade/common/components/map-loading/index.vue';
import colors from '@/styles/color.scss';
import mapStore3d from '@blade-sxp/map/src/store';
let default_1 = class default_1 extends Vue {
    loading = false;
    progress = 0;
    loading2D = false;
    // pathList: any = [];
    get videoList() {
        return store.mapData.videoList;
    }
    get pathList() {
        return store.mapData.pathList;
    }
    get mainAngle() {
        // return { camera: { x: 100, y: 20, z: 200 }, target: { x: 100, y: 20, z: 0 } }; // test数据
        return store.mapData.mainAngle || undefined;
    }
    get toolTipsList() {
        return store.mapData.toolTipsList || [];
    }
    get roiList() {
        return store.mapData.roiList || [];
    }
    get deviceList() {
        return store.mapData.deviceList || [];
    }
    get heatMapList() {
        return store.mapData.heatMapList || [];
    }
    get lineList() {
        return store.mapData.lineList || [];
    }
    get imageList() {
        return store.mapData.imageList || [];
    }
    get autoRotate() {
        return store.mapData.autoRotate ?? true;
    }
    get personList() {
        return store.mapData.personList || [];
    }
    get carParkingList() {
        return store.mapData.carParkingList || [];
    }
    get weather() {
        return store.mapData.weather || 'sunny';
    }
    get sunAngle() {
        return store.mapData.sunAngle || 0;
    }
    get mapUrl() {
        return store.mapData.mapUrl || '';
    }
    get mapId() {
        return store.mapData.mapId || '';
    }
    get backgroundColor() {
        return store.mapData.backgroundColor || colors.black;
    }
    get mapType() {
        return store.mapData.mapType || '2D';
    }
    get operationMode() {
        return store.mapData.operationMode || 'sandTable';
    }
    get travelInitialPosition() {
        return store.travelInitialPosition;
    }
    onChangeMapUrl(newUrl, oldUrl) {
        if (this.mapType === '2D' && newUrl !== oldUrl) {
            this.loading2D = this.$elloading({
                customClass: 'icon-map-loading',
                lock: true,
                spinner: 'el-icon-loading',
                background: colors.taskShadows,
            });
        }
    }
    onChangeMapType() {
        if (this.mapType === '3D-Three.js') {
            this.loading2D.close();
        }
    }
    mapUrlLoad() {
        this.loading2D.close();
    }
    // mounted() {
    // setTimeout(() => {
    //   this.pathList = store.mapData.pathList?.map((item: any) => {
    //     return {
    //       covering: item.pathConfig?.coveringMaterial,
    //       coveringCount: item.pathConfig?.coveringCount,
    //       speed: item.pathConfig?.coveringSpeed,
    //       vertices: item.pathConfig?.roi,
    //       type: item.pathConfig?.type,
    //       width: item.pathConfig?.width,
    //       cycle: item.pathConfig?.cycle,
    //       show: item.pathConfig?.show,
    //       patrol: item.pathConfig?.patrol,
    //     };
    //   });
    // }, 3000);
    // }
    onload() {
        const map = this.$refs.stMap;
        store.updateMapRef(map);
    }
    /** 3D loading start **/
    onStart() {
        this.progress = 0;
        this.loading = true;
    }
    onEnd() {
        mapStore3d.onSmoothChange((isSmooth) => {
            if (isSmooth)
                this.loading = false;
        });
    }
    onError(err) {
        this.loading = false;
        console.log(err);
    }
    onProgress(progress) {
        this.progress = Number((parseInt(String((progress.loaded / progress.total) * 1000)) / 10).toFixed(2));
    }
    /** 3D loading end **/
    handleMapClick(target, targets, position, worldPosition) {
        if (target?.name === 'SEA_REDSEA001')
            return;
        store.updateMapClick();
        this.operationMode === 'travel' && !this.travelInitialPosition && store.updateTravelInitialPosition(position.worldPosition);
    }
};
__decorate([
    Watch('mapUrl')
], default_1.prototype, "onChangeMapUrl", null);
__decorate([
    Watch('mapType')
], default_1.prototype, "onChangeMapType", null);
default_1 = __decorate([
    Component({
        name: 'Map',
        components: { MapLoading, MapCommon },
    })
], default_1);
export default default_1;
